import React from 'react';
import { Box, Stack } from '@mui/material';
import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import Header from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Header';
import { useTranslation } from 'react-i18next';

const InstitutionSection = ({ arrears }: { arrears: Arrears }) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');
  return (
    <Stack spacing={2}>
      <Box
        display="flex"
        flexDirection={{ sm: 'column', md: 'row' }}
        justifyContent="space-between"
      >
        <Header size="xxsmall">{t('commonInformationSection.institutionNumber')}</Header>
        <Body size="body"> {arrears.lenderInstitutionNumber}</Body>
      </Box>
      <Box
        display="flex"
        flexDirection={{ sm: 'column', md: 'row' }}
        justifyContent="space-between"
      >
        <Header size="xxsmall">{t('commonInformationSection.transitNumber')}</Header>
        <Body size="body"> {arrears.lenderTransitNumber}</Body>
      </Box>
      <Box
        display="flex"
        flexDirection={{ sm: 'column', md: 'row' }}
        justifyContent="space-between"
      >
        <Header size="xxsmall">{t('commonInformationSection.municipality')}</Header>
        <Body size="body"> {arrears.lenderTransitMunicipality}</Body>
      </Box>
    </Stack>
  );
};

export default InstitutionSection;
